import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { KaramikoProvider } from "@/components/karamiko/context";
import PaperFilters from "@/components/karamiko/PaperFilters";
import ErrorBoundary from "@/components/karamiko/ErrorBoundary";
import Home from "@/components/karamiko/Home";
import ShowPage from "@/components/karamiko/ShowPage";

function App() {
  useEffect(() => {
    document.documentElement.lang = "ca";
    const base = process.env.PUBLIC_URL || "";
    const root = document.documentElement.style;
    root.setProperty("--bg-paper", `url(${base}/white-bg.jpg)`);
    root.setProperty("--piece-paper", `url(${base}/piece-paper.jpg)`);
    root.setProperty("--kraft-scrap", `url(${base}/kraft-scrap.jpg)`);
    root.setProperty("--sage-scrap", `url(${base}/sage-scrap.jpg)`);
  }, []);

  return (
    <ErrorBoundary>
      <KaramikoProvider>
        <BrowserRouter>
          <PaperFilters />
          <div className="App min-h-screen bg-kraft text-forest" data-testid="karamiko-app">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/espectacles/:slug" element={<ShowPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </BrowserRouter>
      </KaramikoProvider>
    </ErrorBoundary>
  );
}

export default App;
